import MotivoMovimentacaoEstoqueModel from "../models/motivoMovimentacaoEstoque";

import { IService } from "./base/iService";

export default class MotivoMovimentacaoEstoqueService extends IService<MotivoMovimentacaoEstoqueModel> {
    constructor() {
        super("MotivoMovimentacaoEstoque");
    }
}